var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as styles from "./agenda/styles";
import { useDateTime } from "./agenda/utils";
import { Column, Row } from "./agenda/layout";
import { useRef, useState, useEffect } from "react";
import React from "react";
export var AgendaSidebar = function (_a) {
    var events = _a.events, _b = _a.triggerAt, triggerAt = _b === void 0 ? [] : _b;
    var now = useDateTime();
    var column = useRef(null);
    var _c = useState(null), actual = _c[0], setActual = _c[1];
    var _d = useState(events), sessions = _d[0], setSessions = _d[1];
    var _e = useState(new Date().toISOString().split("T")[0]), day = _e[0], setDay = _e[1];
    var startDt = new Date(events[0].start);
    var endDt = new Date(events[events.length - 1].start);
    triggerAt.forEach(function (t) {
        var _a = t[0], startTrigger = _a[0], endTrigger = _a[1], event = t[1];
        if (now >= startTrigger && now <= endTrigger)
            event();
    });
    var dt = new Date();
    if (now < startDt)
        dt = startDt;
    else if (now > endDt)
        dt = endDt;
    if (day !== dt.toISOString().split("T")[0])
        setDay(dt.toISOString().split("T")[0]);
    useEffect(function () {
        var active = sessions.map(isPastPresentFuture).find(function (x) { return x.active; });
        if (!actual || active.id !== actual.id)
            setActual(active);
    }, [now]);
    useEffect(function () {
        var start = new Date("".concat(day, " 00:00:00"));
        var end = new Date("".concat(day, " 23:59:59"));
        setSessions(events.filter(function (ev) { return new Date(ev.start) >= start && new Date(ev.start) < end; }));
    }, [day]);
    useEffect(function () {
        if (column.current === null)
            return;
        var active = column.current.base.getElementsByClassName("active-ev");
        if (active.length === 0)
            return;
        column.current.base.scrollTop = active[0].offsetTop - column.current.base.offsetTop;
    }, [actual]);
    var baseStyle = __assign(__assign({}, styles.fstart), { textDecoration: "none", fontSize: ".8em", marginBottom: "10px", lineHeight: 1.2 });
    var rowStyles = [
        __assign(__assign({}, baseStyle), { color: "#888" }),
        __assign(__assign({}, baseStyle), { fontWeight: "bold", color: "#3c1d4a" }),
        __assign(__assign({}, baseStyle), { color: "#3c1d4a" })
    ];
    var isPastPresentFuture = function (event) {
        var start = new Date(event.start);
        var end = new Date(event.end);
        var farEnd = new Date(new Date(event.end).valueOf() + 7200000);
        if (now > farEnd)
            return __assign(__assign({}, event), { style: { display: "none" } });
        if (now > end)
            return __assign(__assign({}, event), { style: rowStyles[0] });
        else if (now > start && now < end)
            return __assign(__assign({}, event), { active: true, style: rowStyles[1] });
        else if (now < start)
            return __assign(__assign({}, event), { active: false, startDate: start, endDate: end, style: rowStyles[2] });
    };
    return React.createElement(Column, { ref: column, class: "breakout-agenda", styleOverride: {
            overflowX: "hidden",
            overflowY: "scroll",
            scrollbarWidth: "none",
            maxHeight: "100%",
            height: "100%",
            padding: "10px"
        } }, sessions.map(isPastPresentFuture).map(function (event) {
        var start = new Date(event.startDate);
        return React.createElement(Row, { styleOverride: event.style, className: event.active ? "active-ev" : undefined },
            React.createElement("span", { className: "agenda-time" },
                start.getHours() >= 10 ? start.getHours() : "0".concat(start.getHours()),
                ":",
                start.getMinutes() > 10 ? start.getMinutes() : "0".concat(start.getMinutes())),
            React.createElement("span", { className: "agenda-item", style: { marginLeft: "10px" } }, event.title));
    }));
};
